
define('template!webshopAttributesGridView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="toolbar">\n    <span class="toolbar-label">' +
((__t = ( _.i18n('attributeMatching.category', null, 'Category') )) == null ? '' : __t) +
'</span>\n    <div class="category-region"></div>\n    <span class="category-info am-hint"></span>\n    <span class="clear-column-filters" style="display: none"><i class="fa fa-times"></i> ' +
((__t = ( _.i18n('attributeMatching.clearColumnFilters', null, 'Clear the column filters') )) == null ? '' : __t) +
'</span>\n    ' +
((__t = ( subHtml )) == null ? '' : __t) +
'\n    ' +
((__t = ( hideHtml )) == null ? '' : __t) +
'\n    <input type="text" class="product-search am-input" placeholder="' +
((__t = ( _.i18n('attributeMatching.searchProduct', null, 'Code or name') )) == null ? '' : __t) +
'"/>\n    <select class="column-mode am-select" title="' +
((__t = ( _.i18n('attributeMatching.columnModeTitle', null, 'Columns shown') )) == null ? '' : __t) +
'">\n        <option value="both">' +
((__t = ( _.i18n('attributeMatching.columnsBoth', null, 'Filters and attributes') )) == null ? '' : __t) +
'</option>\n        <option value="filters">' +
((__t = ( _.i18n('attributeMatching.columnsFilters', null, 'Webshop filters only') )) == null ? '' : __t) +
'</option>\n        <option value="attributes">' +
((__t = ( _.i18n('attributeMatching.columnsAttributes', null, 'Product attributes only') )) == null ? '' : __t) +
'</option>\n    </select>\n    <select class="add-column am-select"></select>\n    <span class="reload-grid" title="' +
((__t = ( _.i18n('attributeMatching.reloadGridTitle', null, 'Read the products of the category again from the webshop (new products, names, pictures)') )) == null ? '' : __t) +
'"><i class="fa fa-refresh"></i> ' +
((__t = ( _.i18n('common.reload', null, 'Reload') )) == null ? '' : __t) +
'</span>\n</div>\n<div class="am-hint legend">' +
((__t = ( _.i18n('attributeMatching.gridHint', null, 'Click a cell, tick the values and Validate: the product is then pushed to the webshop.') )) == null ? '' : __t) +
'</div>\n' +
((__t = ( legendHtml )) == null ? '' : __t) +
'\n<div class="grid-table"></div>\n<div class="am-pager"></div>\n';

}
return __p
};});

